/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CliniShift Manager
 * The CliniShift Manager API is used to manage the CliniShift platform. This API is used by the CliniShift Manager Portal.
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const NotificationEntityType = zod.union([zod.enum(['shift', 'employee', 'time_off_request', 'org', 'user', 'join_request']),zod.string()]);

export type NotificationEntityType = zod.input<typeof NotificationEntityType>;
export type NotificationEntityTypeOutput = zod.output<typeof NotificationEntityType>;
